document.addEventListener('DOMContentLoaded', function()
{
  const tabs = document.querySelectorAll('.accord__el');

  tabs.forEach(function(tab)
  {
    tab.addEventListener('click', function()
    {

      tabs.forEach(function(subtab)
      {
        subtab.classList.remove('accord__el--active');
      });

      tab.classList.add('accord__el--active');

    });
  });
});
